module.exports = {
  FCA: '&copy; ' + new Date().getFullYear() + ' Marmalade is a trading name of Atlanta Insurance Intermediaries Limited. Authorised and Regulated by the Financial Conduct Authority under firm reference number 309599. Company registration number: 756681. Registered address: Embankment West Tower, 101 Cathedral Approach, Salford, M3 7FB. Atlanta Insurance Intermediaries Limited can be found on the Financial Services Register under reference number 309599. For more information, please contact us. Calls are recorded for training and quality purposes.',
  contact: {
    phone: {
      general: '0330 343 8814',
      office: '0333 323 1328',
      complaint: '01733 207960',
      claims: {
        ndi: {
          allianz: '0345 600 0676',
          lv: '0800 681 6372'
        }
      }
    },
    liveChatLauncherId: '#live-chat',
    facebookProfile: 'WeAreMarmalade',
    twitterHandle: 'wearemarmalade',
    googlePlusID: '113955570060423387353',
    youtubeChannel: 'WeAreMarmalade01',
    email: {
      broker: 'broker@marmalade.co.uk'
    }
  },
  clientId: {
    ndi: '3_b9i0mzi569wk0k4w404s0og08gsgc4g0o4ww8cc040ocs4gc4',
    fdi: '4_4nh75nwnxgu8ogkwgow8884ocsc88kc8wsggso4co4sc84kgok',
    ldi: '7_5nrru5uvng088cos0scoc8g80c08kk0g4g4g400os0gg44w8cg',
    sdi: '12_29jewv6pk6xwksgsk8g04swkoow8oc084kg88kc4c0s4s4ggcw',
    broker: '10_510kjjqda7gokk4ow88oso0kowkkw8w0s8wkco4cckck08cgc8',
    admin: '11_2qckh7lrijacgooss0gggcw8wg8gw8k8o84880ss488k8ossgg'
  },
  breakpoints: {
    xs: 600,
    sm: 768,
    md: 992,
    lg: 1200
  }
};